import { useStore } from "@/state/store";

export function Toast() {
  const toast = useStore((s) => s.toast);
  if (!toast) return null;
  const color =
    toast.kind === "success"
      ? "var(--yes)"
      : toast.kind === "error"
        ? "var(--no)"
        : "var(--accent)";
  return (
    <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 card-in">
      <div
        className="rounded-[12px] border bg-bg-2 px-4 py-3 text-[13px] shadow-[var(--shadow-card)]"
        style={{ borderColor: color, color }}
      >
        {toast.message}
      </div>
    </div>
  );
}
